// extracted by mini-css-extract-plugin
export var banner = "_b7-0";
export var closeButton = "_b7-2";
export var greenCheckmark = "_b7-3";
export var hereLink = "_b7-4";
export var titleIcon = "_b7-1";